<template>
  <div class="container section-p70">
    <div class="row mb-3">
      <div class="col-auto">
        <title-with-results :title="t('DOCUMENTS')" :number-of-results="diplomasRef?.numberOfResults() ?? 0"/>
      </div>
    </div>

    <div class="row mt-3 justify-content-between align-items-center">
      <form class="col" @submit.prevent="onSearch">
        <div class="row align-items-center">
          <div class="col-xl-4 mb-2">
            <Select
              v-model="searchParams.status"
              :options="diplomaStatusOptions"
              :placeholder="t('STATUS')"
              option-label="text"
              option-value="value"
              class="w-100"
              showClear
            />
          </div>
          <div class="col-xl-4 mb-2">
            <InputText
              v-model="searchParams.searchValue"
              type="text"
              :placeholder="t('SEARCH')"
              class="w-100"
            />
          </div>
          <div class="col-xl-4 mb-2">
            <Button type="submit" :label="t('SEARCH')"/>
          </div>
        </div>
      </form>

      <div class="col flex-grow-0">
        <Button :label="t('DOWNLOAD_FILE')" class="text-nowrap" @click="downloadDiplomasExcel"/>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <institution-diplomas :is-compact="true"
                              :rows-per-page="rowsPerPage"
                              :search-params="searchParams"
                              @on-reset="resetSearchParams"
                              ref="diplomasRef"/>
      </div>
    </div>

    <file-downloader ref="fileDownloaderRef"/>
  </div>
</template>

<script setup lang="ts">
import InstitutionDiplomas from "@/views/components/InstitutionDiplomas.vue";
import {useI18n} from "vue-i18n";
import {computed, ref} from "vue";
import {DiplomaStatus} from "@/model/institution-diploma";
import FileDownloader from "@/components/FileDownloader.vue";
import TitleWithResults from "@/components/TitleWithResults.vue";
import {useRoute} from "vue-router";

const {t} = useI18n();
const route = useRoute();

const rowsPerPage = 30;
const diplomasRef = ref<InstanceType<typeof InstitutionDiplomas> | null>(null);
const fileDownloaderRef = ref<InstanceType<typeof FileDownloader> | null>(null);

const searchParams = ref({
  searchValue: route.query.searchValue?.toString() ?? undefined,
  status: route.query.status?.toString() ?? null,
});

const diplomaStatusOptions = computed(() => {
  return Object.keys(DiplomaStatus).map(status => {
    return {
      value: status,
      text: t(`DIPLOMA_STATUSES.${status}`),
    };
  });
});

const resetSearchParams = () => {
  searchParams.value = {
    searchValue: undefined,
    status: null,
  };
};

const onSearch = () => {
  diplomasRef.value?.resetTable();
};

const downloadDiplomasExcel = async () => {
  await fileDownloaderRef.value?.downloadFile("/institutions/diplomas/download/excel", searchParams.value, "institution_diplomas.xlsx");
  await diplomasRef.value?.resetTable();
};
</script>
